import { render, staticRenderFns } from "./advertisementBanner.vue?vue&type=template&id=4b67fd9c&scoped=true&"
import script from "./advertisementBanner.vue?vue&type=script&lang=js&"
export * from "./advertisementBanner.vue?vue&type=script&lang=js&"
import style0 from "./advertisementBanner.vue?vue&type=style&index=0&id=4b67fd9c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b67fd9c",
  null
  
)

export default component.exports